import Logger from '../helpers/Logger'
import mvFetch from '../helpers/mvFetch'


const salesCatToSDA = {
  '211': '369',
  '215': '370',
  '216': '371',
  '217': '372',
  '218': '373',
  '219': '374',
  '220': '375',
  '221': '376',
  '222': '377',
  '212': '378',
  '213': '379',
  '214': '380',
  '210': '368',
  '239': '422',
  '274': '457',
  '52': '268',
  '223': '406',
  '338': '481',
  '552': '676',
  '1': '243'
}

interface ISdaData {
  [dayKey: string]: {
    [sdaKey: string]: number
  }
}

interface ICountData {
  [sdaKey: string]: number
}

export class SDA {
  constructor(readonly gdpr: IGDPR) {}

  public handleKeywordSalesCat(salesCat: string = ''): void {
    this.gdpr.onReady(() => {
      this.updateKeywordSalesCat(salesCat).catch((err) => {
        Logger.debug('SDA Error:', err)
      })
    })
  }

  public async updateKeywordSalesCat(salesCat: string): Promise<void> {
    const matchedSDACategories = this.getMatchedCategories(salesCat)

    const sdaInfo: ISdaData = await mvFetch.fetchJson(
      `https://sda.fyi/update?cats=${matchedSDACategories.join(',')}`,
      'GET',
      null,
      (request) => (request.withCredentials = true)
    )

    const categoryCounts: ICountData = {}
    for (const day in sdaInfo) {
      for (const category in sdaInfo[day]) {
        categoryCounts[category] = categoryCounts[category] || 0
        categoryCounts[category] += sdaInfo[day][category]
      }
    }

    this.setTargeting(categoryCounts)
  }

  private setTargeting(categoryCounts: ICountData): void {
    const sda: string[] = []
    Object.keys(categoryCounts).forEach((category) => {
      if (categoryCounts[category] >= 3) {
        sda.push(category)
      }
    })

    window.$mediavine.web.sda = sda
  }

  private getMatchedCategories(salesCategories: string): string[] {
    const splitCategories = salesCategories.split(',')
    return splitCategories.reduce(
      (matchedCategories: string[], keywordCategory: string) => {
        const matchedCategory = salesCatToSDA[keywordCategory]
        if (matchedCategory) {
          matchedCategories.push(matchedCategory)
        }

        return matchedCategories
      },
      []
    )
  }
}
